import { render } from "./Testimonial2Content.vue?vue&type=template&id=26b5130e&scoped=true&ts=true"
import script from "./Testimonial2Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial2Content.vue?vue&type=script&lang=ts"

import "./Testimonial2Content.vue?vue&type=style&index=0&id=26b5130e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b5130e"]])

export default __exports__